import React, { useEffect, useState } from 'react';
import { Table, createStyles, Flex, Button, Modal, useMantineTheme, Image, Box, Portal, Overlay, Loader } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import PartnerForm from '../forms/PartnerForm';
import { getParticipatingCities, deleteParticipatingCity } from '../../services/api.service';
import DeleteButton from '../buttons/DeleteButton';
import DataTable from '../table/DataTable';
import TableHeader from '../table/TableHeader';
import CustomModal from '../modal/CustomModal';
import CityForm from '../forms/CityForm';
import { useEntityManager } from '../../hooks/useEntityManager';

// Custom styles
const useStyles = createStyles((theme) => ({
  container: {
    padding: theme.spacing.md,
    height: '100%',
  },
  imagePreview: {
    padding: 3,
    border: `1px solid ${theme.colorScheme === 'dark' ? theme.white : theme.black}`,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colorScheme === 'dark' ? theme.white : theme.black,
  }
}));

const Cities = () => {

  const [opened, { open, close }] = useDisclosure(false);
  const theme = useMantineTheme();
  const { classes } = useStyles();
  const {
    isLoading,
    search,
    handleSearchChange,
    filteredEntities: filteredCities,
    isEdit,
    editItem: cityEdit,
    toggleEdit: toggleCityEdit,
    handleCloseModal,
    openDeleteModal,
    isDeleteLoading,
  } = useEntityManager({
    fetchEntities: getParticipatingCities,
    deleteEntity: deleteParticipatingCity,
    entityName: 'Ciudad',
    article: 'eliminada',
    filterKey: 'name',
  });

  const columns = [
    { label: 'ID', key: 'id' },
    { label: 'Nombre', key: 'name' },
    { label: 'Imagen', key: 'image' },
    { label: '', key: 'actions' },
  ];

  const renderRow = (item) => (
    <tr
      key={item.id}
      onClick={(e) => {
        toggleCityEdit(e, item);
        open();
      }}
      style={{ cursor: 'pointer' }}
    >
      <td>{item.id}</td>
      <td>{item.name}</td>
      <td>
        <Image
          src={item.image}
          alt="Logo"
          radius={theme.radius.sm}
          maw={100}
          className={classes.imagePreview}
        />
      </td>
      <td>
        <DeleteButton
          onClick={(e) => {
            e.stopPropagation();
            openDeleteModal(item.id);
          }}
        />
      </td>
    </tr>
  );

  return (
    <>
      {/* Modal */}
      <CustomModal opened={opened}>
        <CityForm
          closeModal={() => {
            close();
            handleCloseModal();
          }}
          isEdit={isEdit}
          city={cityEdit}
        />
      </CustomModal>
      {/* Delete Loader */}
      {isDeleteLoading ?
        <Portal>
          <Overlay
            sx={{ zIndex: 999 }}
            center
            blur={15}
          >
            <Loader size={100} />
          </Overlay>
        </Portal>
        : null}
      <Box className="mainContainer">
        {/* Content */}
        <Flex
          direction="column"
          justify="space-between"
          className={classes.container}
        >
          <TableHeader
            title="Ciudades Participantes"
            buttonLabel="Nueva Ciudad"
            onButtonClick={open}
            searchValue={search}
            onSearchChange={handleSearchChange}
            searchPlaceholder="Buscar ciudades"
          />
          <Flex direction="column">
            {/* Table */}
            <DataTable
              data={filteredCities}
              columns={columns}
              renderRow={renderRow}
              loading={isLoading}
            />
          </Flex>
        </Flex>
      </Box>
    </>
  );

}

export default Cities;
